Vue.asyncComponent('bp-block-type-list', {
    data: function() {
        return {
            q: null,
            blockTypes: [],
            blockGroupings: [],
            collapsedStates: true
        }
    },
    props: {
        dataProvider: {
            type: Object,
            required: true
        }
    },
    computed: {
        /**
         * The block groups that have block types
         */
        activeBlockGroups() {
            return this.blockGroupings.filter(blockGrouping => {
                return this.activeBlockTypes.find(blockType => blockType.groupingId === blockGrouping.id);
            })
        },
        /**
         * Block types that match the current search term if any
         * @return {*[]}
         */
        activeBlockTypes() {
            if (!this.q) {
                return this.blockTypes;
            }

            return this.blockTypes.filter(blockType => {
                return blockType.name?.toLowerCase().includes(this.q.toLowerCase()) ||
                    blockType.nameDefault.toLowerCase().includes(this.q.toLowerCase())
            });
        },
        /**
         * Search active
         * @return {boolean}
         */
        searchActive() {
            return this.q !== null && this.q !== '';
        }
    },
    methods: {
        /**
         * Set actuve block type
         * @param newBlock
         */
        setActiveBlockType(newBlock) {
            this.$emit('activeBlockTypeChanged', newBlock);
        },
        /**
         * Addnew block
         * @param type
         */
        addNewBlock(type) {
            const newBlock = this.dataProvider.getNewBlockByType(type);
            this.$emit('addNewBlock', newBlock);
            this.setActiveBlockType(newBlock);
        },
        /**
         * Block type drag start
         * @param type
         */
        childDragStart(type) {
            this.addNewBlock(type);
        },
        /**
         * Stop dragging a block type
         */
        childDragStop() {
            this.setActiveBlockType(null);
        },
        /**
         * Get block types for the curren blockGrouping
         *
         * @param blockGrouping
         * @return {*[]}
         */
        getBlockTypes(blockGrouping) {
            return this.activeBlockTypes.filter(blockType => blockType.groupingId === blockGrouping.id);
        }
    },
    async created() {
        this.loading = true;
        this.blockGroupings = await this.dataProvider.getBlockGroupings();
        this.blockTypes = await this.dataProvider.getBlockTypes();
        this.loading = false;
        this.collapsedStates = localStorage.getItem(`bp-block-group-collapsed-state`) ?
                JSON.parse(localStorage.getItem(`bp-block-group-collapsed-state`)):
                {};
    }
}, 'blueprints/editor/bp-block-type-list.html');